import React from 'react';

const STAMP = { false: 'f', true: 't', misleading: 'm' };

export const IdioticCardHeader = ({ idioticCardHeaderProps }) => {
  const { title, titleBadge, handleExpandClick, expanded, number } = idioticCardHeaderProps;
  const v = STAMP[String(titleBadge || '').toLowerCase()] || 'f';

  return (
    <div
      className="fi-mc-head"
      onClick={handleExpandClick}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleExpandClick(); } }}
      role="button"
      tabIndex={0}
      aria-expanded={!!expanded}
      aria-label={`${title}: ${titleBadge}`}
    >
      <div className="fi-mc-top">
        <span className="fi-mc-no">{number ? `Statement No. ${number}` : 'Fact check'}</span>
        <span className={`fi-stamp fi-stamp--slam fi-stamp--${v}`}>{titleBadge}</span>
      </div>
      <h3 className={`fi-mc-title fi-ant${title.length > 44 ? ' fi-mc-title--long' : ''}`}>{title}</h3>
    </div>
  );
};
